module.exports = __webpack_public_path__ + "static/media/19.9270b71d.wav";